import React from 'react';
import { Button } from 'antd';
import { IconTravelCase } from '../../../Common/Icon';

import styles from './index.module.scss';
import BusinessItem from './BusinessItem';
import { Business } from '../../../../store/business';

export interface MyBusinessesProps {
  businesses: Business[];
}

export default function MyBusinesses({
  businesses,
}: MyBusinessesProps): React.ReactElement {
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h3>My businesses</h3>
        <Button
          type="primary"
          size="large"
          icon={<IconTravelCase />}
          className={styles.claimBtn}
        >
          Claim Your Business
        </Button>
      </div>
      <div className={styles.items}>
        {businesses.map((business) => (
          <BusinessItem key={business.id} business={business} />
        ))}
      </div>
    </div>
  );
}
